var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"toaster-container"}},_vm._l((_vm.messages),function(alert){return _c('div',{key:alert.id},[_c('toaster',{attrs:{"alert-type":alert.type,"alert-text":alert.text}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }